import React, { useState } from "react";
import "./PostJob.css";
import Navbar8 from "./navbar8";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Fragment } from "react";
import Footer4 from "./footer4";

const PostJob = ({addJob}) => {
  const [formData, setFormData] = useState({
    jobTitle: "",
    category: "",
    location: "",
    experienceRequired: "",
    skillsRequired: "",
    jobsCompleted: "",
    budget: "",
    description: "",
    contact: "",
    image: null,  // For file upload
    imagePreview: "" // For displaying preview
  });

  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
        imagePreview: URL.createObjectURL(file),  // Preview the image
      }));
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newJob = {
      id: Date.now(),
      image: formData.imagePreview,
      name: formData.jobTitle,
      rating: 4.5,
      experience: formData.experienceRequired,
      location: formData.location,
      skills: formData.skillsRequired.split(",").map((s) => s.trim()),
      rate: `₹${formData.budget}/day`,
      completedJobs: 0,
    };

    addJob(newJob);
    navigate("/browse-jobs");

    // Clear the form after submission
    setFormData({
      imageUrl: "",
      jobTitle: "",
      category: "",
      location: "",
      experienceRequired: "",
      skillsRequired: "",
      jobsCompleted: "",
      budget: "",
      description: "",
      contact: "",
      image: null,
      imagePreview: "",
    });
  };

  return (
    <>
    <Navbar8 />
    <div className="post-job-container">
      <h1 className="post-job-title">Post a Job</h1>
      <form className="post-job-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <label>Job Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="input-field"
          />
        </div>

        <div className="job-preview-card">
          {formData.imageUrl && <img src={formData.imageUrl} alt="Job Preview" className="job-preview-image" />}
          <h2 className="job-title">{formData.jobTitle || "Job Title"}</h2>
          <div className="job-meta">
            <p><strong>Experience:</strong> {formData.experienceRequired || "N/A"}</p>
            <p><strong>Location:</strong> {formData.location || "N/A"}</p>
          </div>
          <div className="job-skills">
            {formData.skillsRequired.split(",").map((skill, index) => (
              skill.trim() && <span key={index} className="skill-tag">{skill.trim()}</span>
            ))}
          </div>
          <div className="job-footer">
            <p className="job-budget">₹{formData.budget || "0"}/day</p>
            <p className="job-completed">{formData.jobsCompleted || "0"} Jobs Completed</p>
          </div>
        </div>

        <div className="input-group mt-1">
          <label>Job Title</label>
          <input type="text" name="jobTitle" placeholder="Enter job title" value={formData.jobTitle} onChange={handleChange} className="input-field" required />
        </div>

        <div className="input-group">
          <label>Category</label>
          <select name="category" value={formData.category} onChange={handleChange} className="select-field" required>
            <option value="">Select Category</option>
            <option value="construction">Construction</option>
            <option value="electrical">Electrical</option>
            <option value="plumbing">Plumbing</option>
          </select>
        </div>

        <div className="input-group">
          <label>Location</label>
          <input type="text" name="location" placeholder="Enter job location" value={formData.location} onChange={handleChange} className="input-field" required />
        </div>

        <div className="input-group">
          <label>Experience Required</label>
          <input type="text" name="experienceRequired" placeholder="e.g., 5+ years" value={formData.experienceRequired} onChange={handleChange} className="input-field" required />
        </div>

        <div className="input-group">
          <label>Skills Required (comma-separated)</label>
          <input type="text" name="skillsRequired" placeholder="e.g., Masonry, Scaffolding" value={formData.skillsRequired} onChange={handleChange} className="input-field" required />
        </div>

        <div className="input-group">
          <label>Budget (₹)</label>
          <input type="number" name="budget" placeholder="Enter estimated budget" value={formData.budget} onChange={handleChange} className="input-field" required />
        </div>

        <div className="input-group">
          <label>Jobs Completed</label>
          <input type="number" name="jobsCompleted" placeholder="Enter number of jobs completed" value={formData.jobsCompleted} onChange={handleChange} className="input-field" required />
        </div>

        <NavLink type="submit" className="view-profile-btn mb-2" to='/login'>Post Job</NavLink>
      </form>
    </div>
    <Footer4
      link1={
        <Link to="/home">
          Home
        </Link>
      }
      link2={
        <Fragment>
          <span className="home-text215">About Us</span>
        </Fragment>
      }
      link3={
        <Fragment>
          <span className="home-text216">Contact Us</span>
        </Fragment>
      }
      link4={
        <Fragment>
          <span className="home-text217">FAQ</span>
        </Fragment>
      }
      termsLink={
        <Fragment>
          <span className="home-text219">Terms and Conditions</span>
        </Fragment>
      }
      cookiesLink={
        <Fragment>
          <span className="home-text220">Cookies Policy</span>
        </Fragment>
      }
      privacyLink={
        <Fragment>
          <span className="home-text221">Privacy Policy</span>
        </Fragment>
      }
    ></Footer4>
    </>
  );
};

export default PostJob;
